import { render, staticRenderFns } from "./InsectDescription.vue?vue&type=template&id=88cc7774&scoped=true&"
import script from "./InsectDescription.vue?vue&type=script&lang=js&"
export * from "./InsectDescription.vue?vue&type=script&lang=js&"
import style0 from "./InsectDescription.vue?vue&type=style&index=0&id=88cc7774&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc7774",
  null
  
)

/* custom blocks */
import block0 from "./InsectDescription.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88cc7774')) {
      api.createRecord('88cc7774', component.options)
    } else {
      api.reload('88cc7774', component.options)
    }
    module.hot.accept("./InsectDescription.vue?vue&type=template&id=88cc7774&scoped=true&", function () {
      api.rerender('88cc7774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/InsectDescription.vue"
export default component.exports